exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Led;src:url(" + require("./SIGNUS_LED-R.ttf") + "),url(" + require("./SIGNUS_LED-R.ttf") + ") format(\"embedded-opentype\");font-weight:700}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/assets/fonts.scss
 ** module id = 750
 ** module chunks = 0
 **/